// import { defaultLanguage } from '@/config/projectConfig'
// import zhCN from 'ant-design-vue/es/locale-provider/zh_CN';
  //lang设为''为英文，zhCN为中文
  const state = {
    lang: ''
    
  }
  const mutations = {
    setLang: (state, lang) => {
      if(lang == 'zh'){
        state.lang = "zhCN"
      }else{
        state.lang = null
      }
    }
  }


export default {
    namespaced: true,
    state,
    mutations
}
